// An inline edit belongs to the Target that opened it, not the current panel.
export const canSaveTargetEdit = ({ editTargetId, selectedTargetId, editField, editValue, lifecycleBusy }) =>
   !lifecycleBusy && !!editTargetId && editTargetId === selectedTargetId &&
   ['name', 'resourceId'].includes(editField) && !!editValue.trim();
